import { Dispatch, SetStateAction } from "react";
import { AddLedgerBalanceMonitorFields } from "..";
import { Box } from "src/components/MuiGenerals";
import ThresholdFieldSection from "src/views/Ledger/LedgerBalanceMonitor/components/Common/ThresholdFieldSection";
import LedgerFieldSection from "./components/LedgerFieldSection";
import AlertTypeSection from "src/views/Ledger/LedgerBalanceMonitor/components/Common/AlertTypeSection";
import BalanceIntervalSection from "src/views/Ledger/LedgerBalanceMonitor/components/Common/BalanceIntervalSection";

function Content({
  fields,
  setFields,
  isLowerThresholdInvalid,
  isUpperThresholdInvalid,
}: {
  fields: AddLedgerBalanceMonitorFields;
  setFields: Dispatch<SetStateAction<AddLedgerBalanceMonitorFields>>;
  isLowerThresholdInvalid: boolean;
  isUpperThresholdInvalid: boolean;
}) {
  return (
    <Box
      sx={{
        ".MuiInputLabel-shrink": {
          display: "none",
        },
      }}
    >
      <LedgerFieldSection fields={fields} setFields={setFields} />

      <hr style={{ opacity: 0.5, marginTop: "30px", marginBottom: "24px" }} />

      <AlertTypeSection fields={fields} setFields={setFields} />

      <br />

      <BalanceIntervalSection
        fields={fields}
        setFields={setFields}
        chainName={fields.chainName}
        currency={fields.currency}
        clientId={fields.clientId}
      />

      <br />

      <ThresholdFieldSection
        fields={fields}
        setFields={setFields}
        isLowerThresholdInvalid={isLowerThresholdInvalid}
        isUpperThresholdInvalid={isUpperThresholdInvalid}
      />
    </Box>
  );
}

export default Content;
